export const scrollTo = id => {
  const target = document.getElementById(id) || document.body
  target.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
